import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'

const JoinPasswordExisting = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding center-cont">
				<strong style={{ color: "var(--main-color)" }}>이미 가입한 적이 있으시군요!</strong>
				<h3 className="intro-tit mt_20">비밀번호를 입력해주세요.</h3>
				<div className="password-box mt_30">
					<span className="on" />
					<span className="on" />
					<span />
					<span />
					<span />
					<span />
				</div>
			</div>
		</div>
	)
}

export default JoinPasswordExisting